import { Injectable, signal } from '@angular/core';

export type ToastType = 'success' | 'error';

export interface ToastState {
  show: boolean;
  message: string;
  type: ToastType;
}

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private readonly DEFAULT_SUCCESS = '¡Los cambios se guardaron exitosamente!';
  private readonly DEFAULT_ERROR = 'Lo sentimos, no se pudo completar la acción.';

  readonly state = signal<ToastState>({
    show: false,
    message: '',
    type: 'success',
  });

  private timeoutId?: any;

  showSuccess(message?: string): void {
    this.show({
      show: true,
      message: message || this.DEFAULT_SUCCESS,
      type: 'success',
    });
  }

  showError(message?: string): void {
    this.show({
      show: true,
      message: message || this.DEFAULT_ERROR,
      type: 'error',
    });
  }

  private show(state: ToastState): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }

    this.state.set(state);

    this.timeoutId = setTimeout(() => {
      this.hide();
    }, 4000);
  }

  hide(): void {
    this.state.update((s) => ({ ...s, show: false }));
  }
}
